import React from 'react';
import { useSelector } from 'react-redux';

import FilterModal from '../../vwa/components/filter-modal';
import VWALeftMenu from '../../vwa/components/vwa-left-menu';

export default ({
    filterProps,
    sortingOptions,
    selectedSortOption,
    onSort,
    expandedMobileMenu,
    setExpandedMobileMenu,
    resultsCount,
    clearFilters,
    filterCount,
}) => {
    const isMobile = useSelector(
        state => state && state.ui && state.ui.customBreakpoints && state.ui.customBreakpoints.srp === 'mobile'
    );
    const disable = !resultsCount;
    return isMobile && !disable ? (
        <FilterModal
            isOpen={expandedMobileMenu}
            filterCount={filterCount}
            resultsCount={resultsCount}
            onModalClose={() => setExpandedMobileMenu(false)}
            clearFilters={clearFilters}
            className="hawksearch-modal"
        >
            <VWALeftMenu
                {...(filterProps || {})}
                aligned="right"
                sortValues={sortingOptions}
                sortValue={selectedSortOption}
                onSort={onSort}
                tooltipPosition="left"
                isSearch
            />
        </FilterModal>
    ) : null;
};
